
import React, { useEffect, useState, useRef, createRef } from 'react';


import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';


import { ListBox } from 'primereact/listbox';
import { DialogClose } from '../../types';
import { useIcon } from '../../hooks';
import { FabrixIcon, translate } from '../../common';




export interface FabrixConflictDialogProps {
    id?: string;
    text: string;
    items: any[];
    optionLabel?: string;
    optionValue?: string;
    open: boolean;
    onClose?: DialogClose;
    title: string;
    onClick?: (item: any) => void;

}

/**
 * Presents a list-based conflict resolution dialog allowing users to select existing items.
 * @param props Dialog configuration including content, list options, and callbacks.
 * @returns PrimeReact dialog element listing conflicting records.
 */
export default function FabrixConflictDialog(props: FabrixConflictDialogProps) {

    const icon = useIcon();
    const [_dialogOpen, setDialogOpen] = useState<boolean>(false);
    const _ref = createRef<ListBox>();

    useEffect(() => {
        setDialogOpen(props.open)
    }, [props.open])



    /**
     * Invokes the dismiss callback with the provided payload.
     * @param item Value returned to the caller when the dialog closes.
     */
    const handleClose = (item: any) => {

        if (props.onClose) {
            props.onClose(item)
        }
    }


    /**
     * Builds a simple footer containing a close button.
     * @returns JSX element for the dialog footer.
     */
    const renderFooter = () => {

        return (
            <Button key={`btn-dialog-close`} label={translate("CLOSE")}
                icon={icon(FabrixIcon.dialogCancel)}
                onClick={() => handleClose('')} className={`p-button-outlined fbx-button-outlined confirm-dialog-button `} />

        )

    }



    /**
     * Renders individual conflict items, optionally including an icon indicator.
     * @param option Item supplied by the ListBox.
     * @returns JSX representation for the option row.
     */
    const itemTemplate = (option: any) => {



        let text = option[props.optionLabel || 'name'];
        if (option.icon) {
            let className = icon(option.icon);

            return (
                <div className="fbx-conflict-list-item" onClick={() => handleItemClick(option)}>
                    <i className={`fbx-conflict-list-item-icon ${className}`}></i>
                    <span >{text}</span>
                </div>
            )

        } else {
            return (
                <div className="fbx-conflict-list-item" onClick={() => handleItemClick(option)} >
                    <span>{text}</span>
                </div>
            )
        }

    }

    /**
     * Forwards list item clicks to the caller when provided.
     * @param e Selected item payload.
     */
    const handleItemClick = (e: any) => {
        if (props.onClick) {
            props.onClick(e);
        }

    }


    return (
        <Dialog style={{ width: '50vw', height: '50vh' }} header={props.title} visible={_dialogOpen} className="" footer={renderFooter()} onHide={() => handleClose(0)}>

            <div className="fbx-full-height">
                <div style={{ height: 25, marginBottom: 5 }}>
                    <span dangerouslySetInnerHTML={{ __html: props.text }}></span>
                </div>
                <div style={{ height: 'calc(100% - 30px)' }}>
                    <ListBox ref={_ref} options={props.items} style={{ height: "100%" }} optionValue={props.optionValue} itemTemplate={itemTemplate}
                        optionLabel={props.optionLabel} listClassName="fbx-conflict-list" />
                </div>
            </div>

        </Dialog>
    )
}